import React from "react";
import { nanoid } from "nanoid";
import { Button, Divider, Flex, Spin, Upload } from "antd";
import classes from "../../../ApplicationDetails/Offer/OfferDocuments/OfferDocuments.module.css";

import { useGetApplicationDataToBankQuery } from "../../../../../store/api/applicationBankApi/applicationBank.api";
import { UploadRequestOption } from "rc-upload/lib/interface";
import { validateFile } from "../../../../../utils/utilities/validateFile";
import { useParams } from "react-router-dom";
import {
  UploadOutlined,
  PaperClipOutlined,
  LoadingOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { APPLICATION_BANK_STATUS } from "../../../../../utils/guards/ApplicationBankStatusGuard/types";
import { Guard } from "../../../../../utils/guards/Guard";
import { useGetPermissionQuery } from "../../../../../store/api/permission.api";
import { useUploadOfferDocumentMutation } from "../../../../../store/api/applicationBankApi/offer.api";
import { applicationBankDocumentsApi } from "../../../../../services/documents/documents.api";

const { downloadDocument } = applicationBankDocumentsApi;

export const BankGuaranteeIssuanceDocuments = () => {
  const { applicationBankId } = useParams();
  const { data: applicationBank } = useGetApplicationDataToBankQuery(
    Number(applicationBankId)
  );
  const { data: permissionData } = useGetPermissionQuery(undefined);
  /* const documents = [
    {
      id: 1,
      name: "Документ для выдачи БГ",
      extention: ["Загруженный файл.pdf"],
      document: null,
    },
  ]; */

  const [uploadDocument, { isLoading, originalArgs }] =
    useUploadOfferDocumentMutation();
  const isUploading = (typeDocId: number) => {
    return isLoading && typeDocId === originalArgs?.typeDocId;
  };
  const handleUploadDocument = (
    options: UploadRequestOption,
    typeDocId: number
  ) => {
    const { file } = options;
    const { isValidate } = validateFile(file as File);

    if (isValidate) {
      uploadDocument({
        file: file as File,
        applicationBankId: Number(applicationBankId),
        typeDocId: typeDocId,
      });
    }
  };

  /* const uploadDocumentCallback = useCallback(
    (options: UploadRequestOption, index: number) => {
      const { file } = options;

      const { isValidate, error } = validateFile(file as File);

      if (isValidate) {
        uploadDocument({
          file: file as File,
          applicationBankId: Number(applicationBankId),
     
          typeDocId: applicationBank?.register[index].id,
        });
        updateError(index, "");
      } else {
        updateError(index, error ? error : import { UploadRequestOption } from "rc-upload/lib/interface";"");
      }
    },
    [documents, applicationBankId, uploadDocument]
  ); */
  const handleDownloadDocument = ({
    applicationBankId,
    fileId,
    fileName,
  }: {
    applicationBankId: number;
    fileId: number;
    fileName: string;
  }) => {
    downloadDocument({
      applicationBankId,
      fileId,
      fileName,
    });
  };

  return (
    <>
      <Divider orientation="left" orientationMargin="0">
        Документы для выдачи БГ
      </Divider>

      {applicationBank?.register &&
        applicationBank.register.map((documentGroup) => {
          const key = nanoid();
          return (
            <Flex key={key} vertical>
              <Flex>
                <span>{documentGroup.name}</span>
                <Upload
                  className={classes.uploadButtonWrapper}
                  showUploadList={false}
                  customRequest={(options) =>
                    handleUploadDocument(options, documentGroup.id)
                  }
                >
                  {!!applicationBank?.modified_bank_status.type &&
                    documentGroup.type !== "ANKETA" &&
                    applicationBank.employee_user?.id ===
                      permissionData?.data?.user?.id && (
                      <Guard.ApplicationBankStatus
                        status={applicationBank?.modified_bank_status.type}
                        allowedStatuses={[
                          APPLICATION_BANK_STATUS.SIGNED_MANAGER,
                        ]}
                      >
                        <Button
                          className={classes.uploadButton}
                          disabled={isLoading}
                        >
                          {isUploading(documentGroup.id) ? (
                            <Spin
                              indicator={<LoadingOutlined spin />}
                              size="small"
                            />
                          ) : (
                            <UploadOutlined />
                          )}
                          Загрузить
                        </Button>
                      </Guard.ApplicationBankStatus>
                    )}
                </Upload>
              </Flex>

              <div className={classes.documentList}>
                {Array.isArray(documentGroup.document) &&
                  documentGroup.document?.map((document_child) => {
                    return (
                      <div
                        key={document_child.id}
                        className={classes.documentRow}
                        onClick={() =>
                          handleDownloadDocument({
                            applicationBankId: Number(applicationBankId),
                            fileId: document_child.id,
                            fileName: document_child.name,
                          })
                        }
                      >
                        <PaperClipOutlined className={classes.fileIcon} />
                        <span
                          className={
                            document_child.deleted_at
                              ? classes.uploadedFileName
                              : classes.uploadedFileNameActive
                          }
                        >
                          {document_child.name}
                        </span>
                        <DownloadOutlined className={classes.downloadButton} />
                      </div>
                    );
                  })}
              </div>
              <Divider></Divider>
            </Flex>
          );
        })}
    </>
  );
};
